import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { home } from "../content/home";
import { useContent, Rich, SlotImg, HashLink, prefersReducedMotion } from "../ui/helpers";
import { CtaSignOff } from "../ui/blocks";

/* ---------------- Start with one line (deployment path) ---------------- */
export function DeployPath() {
  const c = useContent(home).path;
  const ref = useRef(null);
  const [drawn, setDrawn] = useState(prefersReducedMotion());
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setDrawn(true), { threshold: 0.4 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  return (
    <section className="path" id="path">
      <div className="k-wrap">
        <div className="path-head rv">
          <h2>{c.title}</h2>
          <p>{c.intro}</p>
        </div>
        <ol className={`track${drawn ? " in" : ""}`} ref={ref}>
          {c.steps.map((s) => (
            <li key={s.title}><p className="k-label">{s.tag}</p><h3>{s.title}</h3><p><Rich text={s.body} /></p></li>
          ))}
        </ol>
        <p className="sec-more rv"><Link className="tlink" to="/platform#deploy">{c.link}</Link></p>
      </div>
    </section>
  );
}

/* ---------------- More to explore (sideways rail) ---------------- */
export function ExploreRail({ onFilm }) {
  const c = useContent(home).explore;
  const rail = useRef(null);
  const step = (dir) => {
    const card = rail.current.querySelector(".k-card");
    rail.current.scrollBy({ left: dir * (card.getBoundingClientRect().width + 20), behavior: "smooth" });
  };
  const inner = (card) => (
    <>
      <span className="card-img"><SlotImg slot={card.media} decorative sizes="(min-width: 700px) 360px, 82vw" /></span>
      <span className="k-label">{card.tag}</span>
      <h3>{card.title}</h3>
      <p>{card.body}</p>
      <span className="go">{card.go} →</span>
    </>
  );
  return (
    <section className="band-light explore">
      <div className="k-wrap">
        <div className="explore-head">
          <h2>{c.title}</h2>
          <div className="rail-ctrl">
            <button type="button" aria-label={c.prev} onClick={() => step(-1)}>←</button>
            <button type="button" aria-label={c.next} onClick={() => step(1)}>→</button>
          </div>
        </div>
        <div className="rail" ref={rail}>
          {c.cards.map((card) => {
            if (card.action === "film") return <button key={card.title} type="button" className="k-card" onClick={onFilm}>{inner(card)}</button>;
            if (card.to) return <Link key={card.title} className="k-card" to={card.to}>{inner(card)}</Link>;
            return <HashLink key={card.title} className="k-card" href={card.href}>{inner(card)}</HashLink>;
          })}
        </div>
      </div>
    </section>
  );
}

/* ---------------- Sign-off / contact band ---------------- */
export function SignOff() {
  const c = useContent(home).signoff;
  return <CtaSignOff id="contact" cta={{ eyebrow: c.eyebrow, title: c.title, body: c.body, button: c.cta }} />;
}

